export default __webpack_public_path__ + "images/identity-card-passport-h-160x160.jpg";